import * as userBehaviorList from '../services/userBehavior';
import dayjs from 'dayjs';

export default {
  namespace: 'userBehavior',
  state: {},
  effects: {
    //权限组
    *getAllRole({ payload: { values }, callback }, { call, put }) {
      const response = yield call(userBehaviorList.getAllRole, values);
      yield put({
        type: 'save',
        payload: {
          roleList: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //行为列表
    *getTrackingLogList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(userBehaviorList.getTrackingLogList, values);
      const { pageNum = 1, pageSize = 10 } = values;
      const startNum = (pageNum - 1) * pageSize;
      //自动生成id
      const trackingData = response.data || {};
      const trackingLogList = trackingData?.data?.map((item, index) => ({
        ...item,
        code: startNum + index + 1,
      }));
      yield put({
        type: 'save',
        payload: {
          trackingLogList,
          trackingData: {
            hasNext: trackingData?.hasNext,
            total: trackingData?.total,
          },
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //用户行为明细轨迹
    *getTrackingLogTrajectory(
      { payload: { values }, callback },
      { call, put },
    ) {
      const response = yield call(
        userBehaviorList.getTrackingLogTrajectory,
        values,
      );
      const list = response?.data?.trackingList || [];
      yield put({
        type: 'save',
        payload: {
          trackingLogTrajectory: list,
          trackingLogTotal: response?.data.num,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    *getTrackingLogTrend({ payload: { values }, callback }, { call, put }) {
      const response = yield call(userBehaviorList.getTrackingLogTrend, values);
      yield put({
        type: 'save',
        payload: {
          trackingLogTrendData: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //用户行为数据详情
    *getTrackingUserDetail({ payload: { values }, callback }, { call, put }) {
      const response = yield call(
        userBehaviorList.getTrackingUserDetail,
        values,
      );
      yield put({
        type: 'save',
        payload: {
          trackingUserDetail: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //用户行为数据排序
    *trackingLogTrajectorysort(
      { payload: { values }, callback },
      { put, select },
    ) {
      const trackingList = yield select(
        (state) => state.userBehavior?.trackingLogTrajectory,
      );
      const { value } = values;
      let data = [];
      if (value === '1') {
        data = trackingList?.sort(
          (a, b) => dayjs(a.eventTime).valueOf() - dayjs(b.eventTime).valueOf(),
        );
      } else {
        data = trackingList?.sort(
          (a, b) => dayjs(b.eventTime).valueOf() - dayjs(a.eventTime).valueOf(),
        );
      }
      yield put({
        type: 'save',
        payload: {
          trackingLogTrajectory: data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(trackingList);
      }
    },
    //报表导出
    *exportTrackingListData({ payload: { values }, callback }, { call }) {
      const response = yield call(
        userBehaviorList.exportTrackingListData,
        values,
      );
      // yield put({
      //   type: 'save',
      //   payload: {
      //     trackingUserDetail: response?.data,
      //   },
      // });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },
  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },
  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
